var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from './providers/authentication/auth.service';
import { SSO } from './providers/nom-web-services-json/sso';
import { SSOService } from './providers/authentication/sso/sso.service';
import 'rxjs/add/operator/pairwise';
var AppComponent = /** @class */ (function () {
    function AppComponent(activatedRoute, location, router, authService, sso, ssoService) {
        this.activatedRoute = activatedRoute;
        this.location = location;
        this.router = router;
        this.authService = authService;
        this.sso = sso;
        this.ssoService = ssoService;
        this.routeSub = this.activatedRoute.queryParams.subscribe(this.paramsChanged.bind(this));
    }
    AppComponent.prototype.ngOnDestroy = function () {
        if (this.routeSub)
            this.routeSub.unsubscribe();
    };
    AppComponent.prototype.paramsChanged = function (p) {
        return __awaiter(this, void 0, void 0, function () {
            var matchToken, providerName, tokenMatches, idToken, redirectUri, _a, action, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        matchToken = {
                            "GOOGLE": /id_token=(.*)&authuser/,
                            "MICROSOFTAZURE": /id_token=(.*)&state/,
                            "MICROSOFTLIVE": /id_token=(.*)&state/,
                            "OKTA": /id_token=(.*)&state/,
                            "ONELOGIN": /access_token=(.*)&expires_in/
                        };
                        providerName = localStorage.getItem("providerName");
                        tokenMatches = window.location.href.match(matchToken[providerName]);
                        idToken = (tokenMatches && (tokenMatches.length > 1)) ? tokenMatches[1] : null;
                        if (!(idToken && !this.activatedRoute.snapshot.params["success"])) return [3 /*break*/, 1];
                        redirectUri = localStorage.getItem("redirectUri");
                        if (redirectUri) {
                            // Web
                            if (redirectUri.indexOf("?") >= 0) {
                                redirectUri += "&";
                            }
                            else {
                                redirectUri += "?";
                            }
                            redirectUri += "providerName=" + encodeURIComponent(providerName) + "&idToken=" + encodeURIComponent(idToken);
                            window.location.href = redirectUri;
                        }
                        else {
                            // Desktop
                            external.receiveJWT(idToken, providerName);
                        }
                        return [3 /*break*/, 5];
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        this.authService.redirectUri = p["redirectUri"];
                        if (this.authService.redirectUri)
                            localStorage.setItem("redirectUri", this.authService.redirectUri);
                        this.authService.providerName = p["providerName"];
                        if (this.authService.providerName)
                            localStorage.setItem("providerName", this.authService.providerName);
                        if (!this.authService.providerName) return [3 /*break*/, 3];
                        _a = this.ssoService;
                        return [4 /*yield*/, this.sso.getSSOSettings()];
                    case 2:
                        _a.ssoSettings = (_b.sent()).data;
                        action = p["action"] ? p["action"].toLowerCase() : "";
                        switch (action) {
                            default:
                                this.authService.authenticate();
                                break;
                        }
                        _b.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        e_1 = _b.sent();
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return AppComponent;
}());
export { AppComponent };



// WEBPACK FOOTER //
// ./src/app/app.component.ts.pre-build-optimizer.js